module.exports = __webpack_public_path__ + "img/emptyapplication.b8048956.svg";